import script from "./AddViolationAction.vue?vue&type=script&setup=true&lang=js"
export * from "./AddViolationAction.vue?vue&type=script&setup=true&lang=js"

import "./AddViolationAction.vue?vue&type=style&index=0&id=48b0f642&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b0f642"]])

export default __exports__